import type {
  AnalysisView,
  AnalysisViewSearchResult,
  PortfolioAccountStatusEnum,
  PrivatePortfolioNode,
} from 'venn-api';

export enum PageType {
  GRID,
  TITLE,
  SECTION,
  CONTENTS,
  DISCLOSURE,
  CONTINUATION,
}

export enum ReportingStyleEnum {
  TEARSHEET = 'TEARSHEET',
  REPORT = 'REPORT',
  TEARSHEET_TEMPLATE = 'TEARSHEET_TEMPLATE',
  REPORT_TEMPLATE = 'REPORT_TEMPLATE',
}

export interface StudioTemplateState {
  newDocument: AnalysisView;
  openAllocatorForPrivatePortfolio?: PrivatePortfolioNode;
  modifiedUnsavedPortfolio?: PrivatePortfolioNode;
  /** Need to refetch full document */
  id?: string;
}

export interface AnalysisViewSearchResultWithUIState extends AnalysisViewSearchResult {
  selected?: boolean;
  templateName?: string;
  ownershipName?: string;
}

export interface PortfoliosLocationState {
  status?: PortfolioAccountStatusEnum[];
}

export enum StudioErrorsEnum {
  SUBJECT_NO_PERMISSION = 'You do not have permission to access this subject.',
  SUBJECT_FAILED_TO_LOAD = 'The subject failed to load.',
}
